module.exports = "https://stanwinstonschool.com/school-our-history.d4c57e75928b0363298a045df4b8c196.png";